import SuppliesTable from "./SuppliesTable";
export default SuppliesTable;
